import { useRealtime } from "@/lib/realtime-context";
import { cn } from "@/lib/utils";

const VARIANTS = {
  live:         { dot: "bg-emerald-500", ring: "bg-emerald-500/40", text: "text-emerald-700", label: "Live" },
  connecting:   { dot: "bg-amber-500",   ring: "bg-amber-500/40",   text: "text-amber-700",   label: "Conectare…" },
  reconnecting: { dot: "bg-amber-500",   ring: "bg-amber-500/40",   text: "text-amber-700",   label: "Reconectare…" },
  offline:      { dot: "bg-zinc-400",    ring: "bg-zinc-400/30",    text: "text-zinc-500",    label: "Offline" },
  error:        { dot: "bg-rose-500",    ring: "bg-rose-500/40",    text: "text-rose-700",    label: "Eroare" },
};

export default function LiveIndicator({ className }) {
  const { status } = useRealtime();
  const v = VARIANTS[status] || VARIANTS.offline;
  const animated = status === "live";
  return (
    <div
      className={cn(
        "hidden sm:inline-flex items-center gap-2 rounded-full border border-border bg-white/70 px-2.5 h-7 text-[11px] font-medium tracking-wide",
        v.text,
        className,
      )}
      title={`Realtime: ${v.label}`}
      data-testid="realtime-indicator"
      data-status={status}
    >
      <span className="relative inline-flex h-2 w-2">
        {animated && (
          <span
            className={cn("absolute inset-0 inline-flex h-full w-full rounded-full opacity-75 animate-ping", v.ring)}
          />
        )}
        <span className={cn("relative inline-flex h-2 w-2 rounded-full", v.dot)} />
      </span>
      <span>{v.label}</span>
    </div>
  );
}
